var exports = {
  "kZ": "xaee3c4fa--6a8b79--image-wrapper",
  "o5": "xaee3c4fa--6a8b79--content-wrapper",
  "vL": "xaee3c4fa--6a8b79--items-wrapper",
};

module.exports = exports;
